import { Link as Link_kojaro } from './Link.kojaro';
import { Link as Link_zoomg } from './Link.zoomg';
import { Link as Link_zoomit } from './Link.zoomit';
import { Link as Link_phosphor } from './Link.phosphor';

const IconRenderer = () => {
  switch (process.env.NEXT_PUBLIC_ICON_SYSTEM) {
    case 'kojaro':
      return Link_kojaro;

    case 'zoomg':
      return Link_zoomg;

    case 'phosphor':
      return Link_phosphor;


    default:
      return Link_zoomit;
  }
};

export const Link = IconRenderer();
